<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :width="220"
      class="surface-0 border-none shadow-1"
    >
      <div class="tw-p-2.5 h-full">
        <div class="h-full relative">
          <Sidebar @toggle-menu="toggle" />
          <Menu
            ref="menu"
            id="overlay_menu"
            class="w-13rem"
            :model="menuItems"
            :popup="true"
            style="z-index: 1012 !important"
          />
          <div
            @click="drawer = !drawer"
            class="tw-w-7 tw-aspect-square tw-cursor-pointer tw-flex tw-justify-center tw-items-center hover:tw-opacity-75 tw-absolute tw-top-2 tw-right-0"
          >
            <SidebarToggle />
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <div
      v-if="!drawer"
      @click="drawer = !drawer"
      class="tw-w-8 tw-h-10 tw-fixed tw-z-50 tw-rounded-r-xl tw-left-0 tw-top-16 tw-bg-violet-200 tw-shadow-sm dark:tw-bg-green-500 tw-cursor-pointer tw-flex tw-justify-center tw-items-center"
    >
      <SidebarToggle :is-open="true" />
    </div>

    <v-main class="flex justify-content-center flex-wrap surface-50">
      <div class="tw-w-full tw-p-2 md:tw-p-3 lg:tw-p-4">
        <router-view />
      </div>
      <Footer />
      <!--  -->
    </v-main>
  </v-app>
</template>

<script setup>
import Sidebar from "../Sidebar.vue";
import Footer from "@/components/Footer.vue";
import Button from "primevue/button";
import Menu from "primevue/menu";
import LogoImg from "@/assets/pulsar.svg";
import { ref } from "vue";
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
import JamxLogo from "../icons/JamxLogo.vue";
import { usePrimeVue } from "primevue/config";
import { computed } from "vue";
import SidebarToggle from "../icons/SidebarToggle.vue";
const drawer = ref(null);
const store = useStore();
const toast = useToast();
const router = useRouter();
const PrimeVue = usePrimeVue();

const menu = ref();
const toggle = (event) => {
  menu.value.toggle(event);
};

const toggleTheme = () => {
  store.commit("switchTheme");
  // PrimeVue.changeTheme("dark", "light", "theme-link", () => {});
  PrimeVue.changeTheme(
    `${store.getters.currentTheme == "dark" ? "light" : "dark"}`,
    `${store.getters.currentTheme}`,
    "theme-link",
    () => {}
  );
};

const getRoleByState = () => {
  if (store.getters.isSellerLoggedIn) {
    return "seller";
  } else if (store.getters.isGroupAdminLoggedIn) {
    return "group-admin";
  } else if (store.getters.isAdminLoggedIn) {
    return "admin";
  } else if (store.getters.isNetworkAdminLoggedIn) {
    return "network-admin";
  } else if (store.getters.isLoggedIn) {
    return "partner";
  }
};

const logout = () => {
  localStorage.clear();
  window.location.replace("/");
};

const switchRoleBetweenPublisherAndPodcaster = () => {
  if (store.getters.isPodcasterLoggedIn) {
    store.commit("setPodcasterLoggedIn", false);
    router.push({ name: "GroupAdminDashboard" });
  } else {
    store.commit("setGroupAdminLoggedIn", false);
    router.push({ name: "PodcasterDashboard" });
  }
};

const switchRoleBetweenAdminAndPodcastAdmin = () => {
  if (store.getters.isAdminLoggedIn) {
    store.commit("setAdminLoggedIn", false);
    router.push({ name: "PodcastAdminDashboard" });
  } else {
    store.commit("setPodcastAdminLoggedIn", false);
    router.push({ name: "AdminDashboard" });
  }
};

const menuItems = computed(() => [
  {
    label: "Options",
    items: [
      {
        label: "Profile",
        icon: "pi pi-user-edit",
        command: () => {
          toast.add({
            severity: "success",
            summary: "Profile",
            detail: "Will be available soon!",
            life: 5000,
          });
        },
      },
      {
        label: "Settings",
        icon: "pi pi-cog",
        command: () => {
          toast.add({
            severity: "success",
            summary: "Settings",
            detail: "Will be available soon!",
            life: 5000,
          });
        },
      },
    ],
  },
  {
    label: "Other",
    items: [
      {
        label: `Switch to ${
          store.getters.isPodcasterLoggedIn ? "Group Admin" : "Podcaster"
        }`,
        icon: "pi pi-users",
        command: switchRoleBetweenPublisherAndPodcaster,
        visible: localStorage.is_both_role == "yes",
      },
      {
        label: `Switch to ${
          store.getters.isPodcastAdminLoggedIn ? "Admin" : "Podcast Admin"
        }`,
        icon: "pi pi-users",
        command: switchRoleBetweenAdminAndPodcastAdmin,
        visible: localStorage.adminToken?.length > 0,
      },
      {
        label: "Logout",
        icon: "pi pi-sign-out",
        command: logout,
      },
    ],
  },
]);
</script>
<script>
export default {
  data: () => ({ drawer: null }),
  components: { Sidebar },
};
</script>

<style scoped>
/* .app-bar-blur {
  background: rgba(var(--surface-0), 0.8) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
} */
</style>
